export default __webpack_public_path__ + "static/media/why6.681ab84b.svg";